import {initializeApp} from 'firebase/app';
import {getAnalytics} from 'firebase/analytics';
import {getAuth} from 'firebase/auth';
import {getFirestore} from 'firebase/firestore';
import {getStorage} from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyA4y0WpGv3rJCG4NXoCol_5r7OLz6eTA8o',
  authDomain: 'cllctve-demo.firebaseapp.com',
  projectId: 'cllctve-demo',
  storageBucket: 'cllctve-demo.firebasestorage.app',
  messagingSenderId: '288588687300',
  appId: '1:288588687300:web:0cd857b6c798fc2c5fa691',
  measurementId: 'G-8ER7QD6TZ1',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firebase services
export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const storage = getStorage(app);
export {analytics};
export default app;
